export const data9_4 = [{
    name: "Linen 布草",
    name_code: "Linen",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Uniform 制服",
    name_code: "Uniform",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Chinaware 瓷器",
    name_code: "Chinaware",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Glasswares 玻璃器皿",
    name_code: "Glasswares",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Silverwares 银器",
    name_code: "Silverwares",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Total",
    name_code: "Total",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}]

export const dataTitle = [{
    name: "Days of the Current Period 本期期间天数:",
    day: 0,
    datename: "Stock-taken Date This Time 本次盘点日期:",
    date: ""
}, {
    name: "Days of the Last Period 上期期间天数:",
    day: 0,
    datename: "Stock-taken Date Last Time 上次盘点日期:",
    date: ""
}];

export const dataContent = [{
    name: "CHINAWARE 瓷器",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Opening Balance 期初余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Purchase 加：本期采购",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Transfer in 加：本期转入",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Transfer out 减：本期转出",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Compensation 减：客人赔偿",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Closing Balance 期末余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage Value 丢失破损值",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage % 丢失破损比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Outlets Loss & Breakage % 各餐厅丢失破损占比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "其中：Breakage Value 报损金额 ",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss Value 丢失金额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "GLASSWARE 玻璃",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Opening Balance 期初余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Purchase 加：本期采购",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Transfer in 加：本期转入",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Transfer out 减：本期转出",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Compensation 减：客人赔偿",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Closing Balance 期末余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage Value 丢失破损值",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage % 丢失破损比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Outlets Loss & Breakage % 各餐厅丢失破损占比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "其中：Breakage Value 报损金额 ",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss Value 丢失金额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "SILVERWARE 银器",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Opening Balance 期初余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Purchase 加：本期采购",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Transfer in 加：本期转入",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Transfer out 减：本期转出",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Compensation 减：客人赔偿",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Closing Balance 期末余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage Value 丢失破损值",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage % 丢失破损比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Outlets Loss & Breakage % 各餐厅丢失破损占比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "其中：Breakage Value 报损金额 ",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss Value 丢失金额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "LINEN 布草",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Opening Balance 期初余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Purchase 加：本期采购",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Add: Transfer in 加：本期转入",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Transfer out 减：本期转出",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Less: Compensation 减：客人赔偿",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Closing Balance 期末余额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage Value 丢失破损值",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage % 丢失破损比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Outlets Loss & Breakage % 各餐厅丢失破损占比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "其中：Breakage Value 报损金额 ",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss Value 丢失金额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Total Loss & Breakage Value 丢失破损值总计",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Total Loss & Breakage % 丢失破损比总计",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Outlets Total Loss & Breakage % 各餐厅丢失破损占比总计",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "其中：Breakage Value 报损金额 ",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss Value 丢失金额",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Total F&B (Rooms) Covers: 餐厅用餐（客房）人数总计",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Total F & B (Rooms) Revenue: 餐厅（客房）总收入",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage Per Cover: 丢失破损值分摊至每位客人",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss & Breakage by Day: 丢失破损值分摊至每天",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Breakage % to F & B (Rooms) Revenue: 破损值与餐厅（客房）收入占比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}, {
    name: "Loss  % to F & B (Rooms) Revenue: 丢失值与餐厅（客房）收入占比",
    shop: 0,
    Chinese: 0,
    Thai: 0,
    banquet: 0,
    lounge: 0,
    stewarding: 0,
    total: 0,
    last: 0,
    var: 0,
    rooms: 0,
    last_total: 0,
    last_var: 0,
    others: 0,
}];


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-4/data.js